<template>
  <v-layout>
    <v-flex grow style="flex-basis: 300px">
      <v-layout>
        <v-flex>
          <v-subheader>{{ availableLabel }}</v-subheader>
        </v-flex>
        <v-flex v-if="isShowAllSelect" class="inline-block text-xs-right" xs5>
          <v-btn
            v-if="
              visibleAvailableItems.length === selectedAvailableItems.length &&
                !disabledChoseButton
            "
            @click="clickAllSelectLeft(false)"
          >
            選択を解除
          </v-btn>
          <v-btn
            v-else
            @click="clickAllSelectLeft(true)"
            :disabled="disabledChoseButton"
          >
            すべて選択
          </v-btn>
        </v-flex>
      </v-layout>
      <select multiple class="select-list select-list-height">
        <option
          v-for="item in visibleAvailableItems"
          :key="item.index"
          :value="item.value"
          :selected="item.selected"
          :class="[
            'list-item px-2',
            { isSelected: item.selected, isDisabled: isDisabled(item) },
          ]"
          @click.prevent="onClickAvailableItem(item)"
          @dblclick.prevent="instantChose(item)"
          >{{ item.name }}</option
        >
      </select>
    </v-flex>
    <v-flex justify-center align-self-center shrink>
      <v-layout column>
        <v-btn
          :disabled="disabledChoseButton"
          @click="choseSelectedAvailableItems"
          icon
          large
        >
          <v-icon x-large>arrow_right</v-icon>
        </v-btn>
        <v-btn
          :disabled="disabledRejectButton"
          @click="rejectSelectedChosenItems"
          icon
          large
        >
          <v-icon x-large>arrow_left</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex grow style="flex-basis: 300px">
      <v-layout>
        <v-flex>
          <v-subheader>{{ chosenLabel }}</v-subheader>
        </v-flex>
        <v-flex v-if="isShowAllSelect" class="inline-block text-xs-right" xs5>
          <v-btn
            v-if="
              visibleChosenItems.length === selectedChosenItems.length &&
                !disabledRejectButton
            "
            @click="clickAllSelectRight(false)"
          >
            選択を解除
          </v-btn>
          <v-btn
            v-else
            @click="clickAllSelectRight(true)"
            :disabled="disabledRejectButton"
          >
            すべて選択
          </v-btn>
        </v-flex>
      </v-layout>
      <select multiple class="select-list select-list-height">
        <option
          v-for="item in visibleChosenItems"
          :key="item.index"
          :value="item.value"
          :selected="item.selected"
          :class="[
            'list-item px-2',
            { isSelected: item.selected, isDisabled: isDisabled(item) },
          ]"
          @click.prevent="onClickChosenItem(item)"
          @dblclick.prevent="instantReject(item)"
          >{{ item.name }}</option
        >
      </select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AppTwoColumnsSelector',
  props: {
    availableLabel: {
      type: String,
      default: '',
    },
    chosenLabel: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    value: {
      type: Array,
      default: () => [],
    },
    isShowAllSelect: {
      type: Boolean,
      default: false,
    },
    rejectPermitter: {
      type: Function,
      default: null,
    },
    isDisabled: {
      type: Function,
      default: () => false,
    },
  },
  data() {
    return {
      availableItems: [],
    }
  },
  computed: {
    visibleAvailableItems() {
      return this.availableItems.filter(item => !item.chosen)
    },
    visibleChosenItems() {
      return this.availableItems.filter(item => item.chosen)
    },
    selectedAvailableItems() {
      return this.visibleAvailableItems.filter(item => item.selected)
    },
    selectedChosenItems() {
      return this.visibleChosenItems.filter(item => item.selected)
    },
    disabledChoseButton() {
      return this.visibleAvailableItems.length === 0
    },
    disabledRejectButton() {
      return this.visibleChosenItems.length === 0
    },
  },
  watch: {
    value() {
      this.initAvailableItems()
      this.refreshChosenItems()
    },
    items() {
      this.initAvailableItems()
      this.refreshChosenItems()
    },
  },
  created() {
    this.initAvailableItems()
    this.refreshChosenItems()
  },
  methods: {
    initAvailableItems() {
      this.availableItems = this.items.map((data, index) => {
        const name = data[this.itemText]
        const value = data[this.itemValue]
        const ret = Object.assign(
          {
            index,
            chosen: false,
            selected: false,
            name,
            value,
          },
          data,
        )
        return ret
      })
    },
    refreshChosenItems() {
      const isChosen = v => this.value.includes(v)
      this.availableItems
        .filter(item => !item.chosen)
        .forEach(item => {
          item.chosen = isChosen(item.value)
        })
    },
    onClickAvailableItem(item) {
      item.selected = !item.selected
      this.$emit(
        'selectedAvailableItems',
        this.selectedAvailableItems.map(item => item.value),
      )
    },
    onClickChosenItem(item) {
      item.selected = !item.selected
      this.$emit(
        'selectedChosenItems',
        this.selectedChosenItems.map(item => item.value),
      )
    },
    clearSelected() {
      this.availableItems.forEach(item => (item.selected = false))
      this.$emit(
        'selectedAvailableItems',
        this.selectedAvailableItems.map(item => item.value),
      )
      this.$emit(
        'selectedChosenItems',
        this.selectedChosenItems.map(item => item.value),
      )
    },
    choseSelectedAvailableItems() {
      this.selectedAvailableItems.forEach(item => {
        item.chosen = true
        item.selected = false
      })
      this.$emit(
        'changeChosenItems',
        this.visibleChosenItems.map(item => item.value),
      )
      this.clearSelected()
    },
    rejectSelectedChosenItems() {
      this.selectedChosenItems.forEach(item => {
        if (this.rejectPermitter !== null && !this.rejectPermitter(item))
          return false
        item.chosen = false
        item.selected = false
      })
      this.$emit(
        'changeChosenItems',
        this.visibleChosenItems.map(item => item.value),
      )
      this.clearSelected()
    },
    instantChose(item) {
      this.clearSelected()
      this.onClickAvailableItem(item)
      this.choseSelectedAvailableItems()
    },
    instantReject(item) {
      if (this.rejectPermitter !== null && !this.rejectPermitter(item)) return
      this.clearSelected()
      this.onClickChosenItem(item)
      this.rejectSelectedChosenItems()
    },
    clickAllSelectLeft(value) {
      this.visibleAvailableItems.map(item => (item.selected = value))
    },
    clickAllSelectRight(value) {
      this.visibleChosenItems.map(item => (item.selected = value))
    },
  },
}
</script>

<style scoped lang="scss">
.select-list {
  width: 100%;
  border: 1px solid black;
  overflow-y: scroll;
}

.select-list-height {
  height: 150px;
}

.list-item {
  cursor: pointer;

  &.isSelected {
    background-color: rgba(#1976d2, 0.6);
  }
  &.isDisabled {
    color: #ccc;
  }
}
</style>
